import { Stack } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useRef, useState } from 'react'

import Filter from '../../Layout/Dialogs/Filter.jsx'
import Count from '../../Shared/Components/Count.jsx'
import { OrganizationsFilter, TriggerOthersFilters } from '../../Shared/Filters/Fields/index.js'


const TriggersFilters = ({ filters, onChange, itemsCount }) => {
  const [selectedOrganizations, setSelectedOrganizations] = useState(false)
  const [selectedOthers, setSelectedOthers] = useState(false)
  const [announcementUpdatePage, setAnnouncementUpdatePage] = useState('')
  const shouldAnnounceUpdatePage = useRef(false)
  const previousItemsCount = useRef(itemsCount)

  const handleOnDeleteOrganizations = () => {
    setSelectedOrganizations(false)
    onChange({
      ...filters,
      organizationKeys: [],
      searchInSubOrganizations: false
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleOnDeleteOthers = () => {
    setSelectedOthers(false)
    onChange({
      ...filters,
      triggerTypes: [],
      isUsedInRule: false,
      brandNamesEncoded: [],
      modelIds: []
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleOrganizationsChange = (data) => {
    setSelectedOrganizations(true)
    onChange({
      ...filters,
      ...data
    })
  }

  const handleOthersChange = (data) => {
    setSelectedOthers(true)
    onChange({
      ...filters,
      ...data
    })
  }

  const handleFilterClose = () => {
    shouldAnnounceUpdatePage.current = true
    announceUpdatePage()
  }

  const getAnnouncementMessage = () => {
    if (itemsCount === 0) {
      return t('filters.accessibility.noItemsFound')
    } else if (itemsCount === 1) {
      return t('filters.accessibility.oneItemFound')
    } else {
      return t('filters.accessibility.itemsFound', { count: itemsCount })
    }
  }

  const announceUpdatePage = () => {
    setAnnouncementUpdatePage('')

    setTimeout(() => {
      setAnnouncementUpdatePage(getAnnouncementMessage())
    }, 100)
  }

  useEffect(() => {
    if (shouldAnnounceUpdatePage.current && previousItemsCount.current !== itemsCount) {
      announceUpdatePage()
      shouldAnnounceUpdatePage.current = false
    }
    previousItemsCount.current = itemsCount
  }, [itemsCount])

  const filterUnits = [
    {
      label: t('common.organization'),
      id: 'chip-filters-triggers-organizations',
      selected: selectedOrganizations,
      onDelete: handleOnDeleteOrganizations,
      onClose: handleFilterClose,
      content: (
        <OrganizationsFilter
          onChange={handleOrganizationsChange}
          filters={filters}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    },
    {
      label: t('common.filters.other'),
      id: 'chip-filters-triggers-other',
      selected: selectedOthers,
      onDelete: handleOnDeleteOthers,
      onClose: handleFilterClose,
      content: (
        <TriggerOthersFilters
          onChange={handleOthersChange}
          filters={filters}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    }
  ]

  return (
    <>
      {/* Live region per annunci screen reader */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      >
        {announcementUpdatePage}
      </div>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        {filterUnits.map((e, i) => (
          <Filter
            key={`trigger-filter-${i}`}
            id={e.id}
            onClick={e.onClick}
            onDelete={e.onDelete}
            onClose={e.onClose}
            selected={e.selected}
            title={e.label}
            hidden={e.hidden || false}
            content={e.content}
            count={e.count}
          />
        ))}
      </Stack>
    </>
  )
}

export default TriggersFilters
